



<!-- Logo Section -->
<div class="logo">
  <a class="simple-text logo-mini">
    <div class="logo-img">
      <img src="/assets/logo/sidebar-logo.png" />
    </div>
  </a>
  <a routerLink="/" class="simple-text logo-normal">
    <img src="/assets/logo/brand-text.png" />
  </a>
</div>

<div class="sidebar-wrapper">

  <!-- User Card -->
  <div class="user-card">
    <div class="user-avatar">
      <span>{{ username?.charAt(0)?.toUpperCase() }}</span>
    </div>
    <div class="user-info">
      <span class="user-name">{{ username }}</span>
      <span class="user-role">Administrator</span>
    </div>
    <span class="user-status-dot"></span>
  </div>

  <!-- Mobile Search -->
  <div *ngIf="isMobileMenu()" class="mobile-search">
    <i class="material-icons search-icon">search</i>
    <input type="text" placeholder="Search..." class="search-input" />
  </div>

  <!-- Navigation -->
  <ul class="nav-menu">

    <li *ngFor="let item of menuItems"
        routerLinkActive="active"
        class="nav-item">

      <!-- Link type -->
      <a [routerLink]="[item.path]"
         *ngIf="item.type === 'link'"
         class="nav-link"
         routerLinkActive="active-link">
        <i class="material-icons nav-icon">{{ item.icontype }}</i>
        <span class="nav-label">{{ item.title }}</span>
      </a>

      <!-- Sub menu type -->
      <button *ngIf="item.type === 'sub'"
              class="nav-link submenu-toggle"
              [class.open]="isMenuOpen[item.collapse]"
              (click)="expandOrCollapseMenu(item.collapse)">
        <i class="material-icons nav-icon">{{ item.icontype }}</i>
        <span class="nav-label">{{ item.title }}</span>
        <i class="material-icons caret-icon"
           [class.rotated]="isMenuOpen[item.collapse]">expand_more</i>
      </button>



      <div [id]="item.collapse" class="collapse submenu" *ngIf="item.type==='sub'">
        <ul class="nav">
            <li *ngFor="let child of item.children" routerLinkActive="active">
                <a [routerLink]="[item.path,child.path]" class="submenu-link">
                    <span class="badge">{{child.ab}}</span>
                    <span>{{child.title}}</span>
                </a>
            </li>
        </ul>

    </div>
      <!-- Submenu children -->
      <div *ngIf="item.type === 'sub'"
           class="submenu"
           [class.submenu-open]="isMenuOpen[item.collapse]">
        <ul class="submenu-list">
          <li *ngFor="let child of item.children" routerLinkActive="active">
            <a [routerLink]="[item.path,child.path]" class="submenu-link">
              <span class="child-badge">{{ child.ab }}</span>
              <span class="child-label">{{ child.title }}</span>
            </a>
          </li>
        </ul>
      </div>

    </li>

  </ul>

  <!-- Logout Footer -->
  <div class="sidebar-footer">
    <button class="logout-btn" (click)="logout()">
      <i class="material-icons">exit_to_app</i>
      <span>Logout</span>
    </button>
  </div>

</div>
